import { createRouter, createWebHashHistory } from "vue-router";
import Home from "@/view/home/homeView.vue";
import Deposit from "@/view/deposit/depositView.vue";
import Withdraw from "@/view/withdraw/withdrawView.vue";
import Profile from "@/view/profile/profileView.vue";
import Avatar from "@/view/profile/avatarView.vue";
import AccuFund from "@/view/accuFund/accuFundView.vue";
import GiftCode from "@/view/giftCode/giftCodeView.vue";
import Bonus from "@/view/bonus/bonusView.vue";
import VIP from "@/view/vip/vipView.vue";
import GameView from "@/view/game/gameView.vue";
import Offers from "@/view/offers/offersView.vue";
import WeeklyCompensation from "@/view/WeeklyCompensation/weeklyCompensationView.vue";
import Funds from "@/view/funds/fundsView.vue";
import BauDoTesouroView from "@/view/bauDoTesouro/bauDoTesouroView.vue";
import Level from "@/view/level/levelView.vue";
import GameLog from "@/view/gameLog/gameLogView.vue";
import Message from "@/view/message/messageView.vue";
import CashWheel from "@/view/cashWheel/cashWheelView.vue";
import Report from "@/view/report/reportView.vue";
import FirstRecharge from "@/view/firstRecharge/firstRecharge.vue";
import FirstDeposit from "@/view/firstDeposit/newFirstRecharge.vue";
import LossFundReport from "@/view/lossReliefFunds/lossFundReport.vue";
import RechargeGift from "@/view/rechargeGift/rechargeGift.vue";
import ReturnTurnover from "@/view/returnTurnover/returnTurnover.vue";
import CheckinRewards from "@/view/checkinRewards/checkinRewards.vue";
import ActiveChest from "@/view/activeChest/activeChestView.vue";
import InvitedPlayers from "@/view/activeChest/components/chestUserDetails.vue";
import ActiveBonus from "@/view/activeBonus/activeBonusView.vue";
import ErrorNotice from "@/view/Notice/errorNotice.vue";
import CarteiraView from "@/view/carteiraView/carteiraView.vue";
import FundHistory from "@/view/fundHistory/fundHistory.vue";
import ProfilePage from "@/view/profile/profilePage.vue";
import Promotion from "@/view/promotion/promotionPopup.vue";
import WithdrawPWPage from "@/view/withdraw/withdrawPWPage.vue";
import WithdrawPWCompletion from "@/view/withdraw/withdrawPWCompletion.vue";
import MessageContentView from "@/view/message/mssageContentView.vue";
import AgentPopup from "@/view/agent/agentPopup.vue";
import GameSearchPage from "@/view/home/gameSearchPage.vue";
import GamePopup from "@/view/game/gamePopup.vue";
import MisteryBoxView from "@/view/misteryBox/misteryBoxView.vue";

const routes = [
  { path: "/", name: "", component: Home },
  { path: "/home", name: "Home", component: Home },
  { path: "/sd-topup", name: "Deposit", component: Deposit },
  { path: "/sd-withdraw", name: "Withdraw", component: Withdraw },
  { path: "/sd-profile", name: "Profile", component: Profile },
  { path: "/sd-avatar", name: "Avatar", component: Avatar },
  { path: "/sdfundo", name: "AccumulationFund", component: AccuFund },
  { path: "/giftcode", name: "GiftCode", component: GiftCode },
  { path: "/sdmystery", name: "Bonus", component: Bonus },
  { path: "/sd-vip", name: "VIP", component: VIP },
  { path: "/sdagency", name: "BauDoTesouroView", component: BauDoTesouroView },
  { path: "/pgame", name: "Game", component: GameView },
  { path: "/sdbigdep", name: "Offers", component: Offers },
  {
    path: "/weekly",
    name: "WeeklyCompensation",
    component: WeeklyCompensation,
  },
  { path: "/funds", name: "Fund", component: Funds },
  { path: "/sd-level", name: "Level", component: Level },
  { path: "/sd-gamelog", name: "GameLog", component: GameLog },
  { path: "/sd-message", name: "Message", component: Message },
  { path: "/cashwheel", name: "CashWheel", component: CashWheel },
  { path: "/sdagusers", name: "Report", component: Report },
  { path: "/firstRecharge", name: "FirstRecharge", component: FirstRecharge },
  { path: "/firstDeposit", name: "FirstDeposit", component: FirstDeposit },
  { path: "/lossRelief", name: "LossRelief", component: LossFundReport },
  { path: "/rechargeGift", name: "RechargeGift", component: RechargeGift },
  { path: "/returnTrunover", name: "ReturnTurnover", component: ReturnTurnover },
  { path: "/checkinRewards", name: "CheckinRewards", component: CheckinRewards },
  { path: "/sdactivechest", name: "ActiveChest", component: ActiveChest },
  { path: "/sdchestuser", name: "InvitedPlayers", component: InvitedPlayers },
  { path: "/activeBonus", name: "ActiveBonus", component: ActiveBonus },
  { path: "/notice", name: "ErrorNotice", component: ErrorNotice },
  { path: "/sd-carteira", name: "Carteira", component: CarteiraView},
  { path: "/fundsHistory", name: "FundsHistory", component: FundHistory},
  { path: "/profile", name: "ProfilePage", component: ProfilePage },
  { path: "/promotion", name: "Promotion", component: Promotion },
  { path: "/withdrawPW", name: "WithdrawPW", component: WithdrawPWPage},
  { path: "/withdrawPWCompletion", name: "WithdrawPWCompletion", component: WithdrawPWCompletion},
  { path: "/messageContent", name: "MessageContent", component: MessageContentView},
  { path: "/searchGames", name: "SearchGames", component: GameSearchPage},
  { path: "/agent", name: "Agent", component: AgentPopup},
  { path: "/games", name: "Games", component: GamePopup},
  { path: "/misteryBox", name: "MisteryBox", component: MisteryBoxView},
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
